"use strict";
var TransactionReconciliation = (function () {
    function TransactionReconciliation() {
    }
    return TransactionReconciliation;
}());
exports.TransactionReconciliation = TransactionReconciliation;
//# sourceMappingURL=D:/a/1/s/edit/src/models/edit-transaction-reconciliation.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/edit-transaction-reconciliation.model.js